import MapContainer from "./MapContainer";
import React, { Component } from "react";
import { selectMapKey } from "./MapSelector";
import { connect } from "react-redux";

class MapWrapper extends Component {
    render() {
        if (!this.props.mapKey) {
            return null;
        } else {
            return <MapContainer {...this.props} />;
        }
    }
}
export default connect(store => {
    return {
        mapKey: selectMapKey(store)
    };
}, {})(MapWrapper);
